import React from 'react'
import CryptoLogo from 'components/ui-kit/CryptoLogo'
import './index.scss'

const CasinoCard = (props) => {
  const { title, desc, image, onClick } = props

  return (
    <div
      className='flex gap-3 items-center justify-start p-2'
      onClick={onClick}
    >
      <div className='w-8 h-8'>
        {image && !((desc || title || '').toUpperCase().includes('USDT') || (desc || title || '').toUpperCase().includes('TETHER'))
        ? (
          <img
            className='w-8 h-8 object-contain'
            src={image}
            alt={title}
            onError={(e) => { e.target.style.display = 'none' }}
          />
          )
        : (
          <CryptoLogo code={desc || title} name={title} size={32} />
        )}
      </div>
      <div>
        <h4 className='text-base font-bold my-0'>{title}</h4>
        <p className='text-sm text-gray-500 my-0'>{desc}</p>
      </div>
    </div>
  )
}

export default React.memo(CasinoCard)
